<script>
	//Services
	import { postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, Text, toast } from '@Shelly/shelly-design-system';
	export let device;

	const settings = readDeviceSettings(device.id);
	let min = 0,
		max = 5,
		loading = false;

	let value = settings.remain_awake;
	let cache = value;

	const validate = () => {
		if (value > max) {
			value = max;
		}
		if (value < min) {
			value = min;
		}
		return value;
	};

	const setAwakeTime = async () => {
		if (cache !== value) {
			value = validate();
			loading = true;
			const res = await postReq(`/device/inputs_reader/remain_awake`, {
				id: real_id(device.id),
				remain_awake: value,
			});
			if (res.isok) {
				toast.open({
					type: 'success',
					title: $format('remain_awake_scc_toast', {
						values: { value },
						default: `Awake time was set to ${value}s.`,
					}),
				});
				settings.remain_awake = value;
				devices_settings.update_devices_settings(real_id(device.id), settings);
				cache = value;
			} else {
				toast.open({
					type: 'danger',
					title: $format('remain_awake_info_toast', {
						values: { min, max },
						default: `Values must be between ${min} and ${max}.`,
					}),
				});
				value = cache;
			}
			loading = false;
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('remain_awake_description', { values: { min, max } }) ||
		'The number of seconds until the button sleeps after a button push. Values are between {min} - {max} seconds.'}
</Text>
<Input
	icon="fas fa-clock"
	class="mb-s"
	size="m"
	bind:value
	type={'number'}
	on:input={validate}
	{min}
	{max}
	on:enter={setAwakeTime}
	id="input-w50tq7p"
	aria-label={$format('remain_awake_description', { values: { min, max } }) ||
		'The number of seconds until the button sleeps after a button push. Values are between {min} - {max} seconds.'}
/>
<Button class="mt-s" {loading} size="m" width="full" on:click={setAwakeTime}>
	{$format('button_save')}
</Button>
